import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ValidationProvider } from 'vee-validate';
import CInput from '@/components/shared/CInput/CInput.vue';
import CSelect, { valueReducer } from '@/components/shared/CSelect';
import { appStoreListings, providerSignUps, storeTypeOptions } from '@/views/SignUp/storeTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreFields',
  props: {
    storeType: null,
    storeUrl: null,
    lockStoreType: { type: Boolean }
  },
  emits: ["update:storeType", "update:storeUrl"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:storeType', value: string): void;
    (event: 'update:storeUrl', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    storeType: string;
    storeUrl: string;
    lockStoreType?: boolean;
};





const storeTypeModel = computed({
    get: () => props.storeType,
    set: (value: string) => emit('update:storeType', value)
});

const storeUrlModel = computed({
    get: () => props.storeUrl,
    set: (value: string) => emit('update:storeUrl', value)
});

const appStoreListing = computed(() => appStoreListings[props.storeType]);
const providerSignUp = computed(() => providerSignUps[props.storeType]);
const isAmazon = computed(() => props.storeType === 'Amazon');

const urlPlaceholder = computed(() => {
    switch (props.storeType) {
        case 'Amazon':
            return 'Store Name';
        case 'Etsy':
            return 'www.etsy.com/shop/YourShopName';
        default:
            return 'Ecommerce URL';
    }
});

return { __sfc: true,props, emit, storeTypeModel, storeUrlModel, appStoreListing, providerSignUp, isAmazon, urlPlaceholder, ValidationProvider, CInput, CSelect, valueReducer, storeTypeOptions }
}

})